export default "/static/psychotherapy-notes-ui/assets/img/loading-error.6d5e5fe1.png";